<template>
  <div v-if="isVisible" class="absolute inset-0 z-30">
    <div class="surface flex h-full flex-col rounded-md">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-x-2 p-2">
          <slot name="title" class="font-medium" />
        </div>
        <GeneralButton
          :icon="['fas', 'xmark']"
          variant="transparent"
          color="surface"
          size="large"
          class="self-start"
          @click="closeModal"
        />
      </div>
      <div class="flex min-h-0 flex-1 flex-col overflow-y-auto p-2 pt-0">
        <slot></slot>
      </div>
      <div v-if="$slots.footer" class="border-gray-lighten-2 flex justify-end border-t p-2">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import GeneralButton from "@/components/inputs/GeneralButton.vue"
import { onKeyStroke } from "@vueuse/core"
const props = defineProps({
  isVisible: Boolean
})

const emit = defineEmits(["closeModal"])

function closeModal() {
  emit("closeModal")
}

onKeyStroke("Escape", () => {
  if (props.isVisible) {
    emit("closeModal")
  }
})
</script>

<style scoped></style>
